<template lang="pug">
  div Sorry
</template>

<script>
export default {
  name: "NotFound"
};
</script>
